import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

interface Props {
  hasIcon?: boolean;
}

export const DropdownButton = styled(Button)<Props>`
  user-select: none;
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  transition: none;
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  > button {
    border-radius: ${({ theme }) => theme.x2spacePx}px;
  }
  span {
    color: ${({ theme }) => theme.color.white};
  }

  padding-left: ${({ hasIcon, theme }) =>
    hasIcon ? theme.x4spacePx : theme.x2spacePx}px;
  padding-right: ${({ theme }) => theme.x4spacePx}px;
  > svg {
    &:first-child {
      left: 8px;
      opacity: 1;
      fill: ${({ theme }) => theme.color.brand01};
    }
    &:last-child {
      right: 4px;
    }
  }
`;
